<template>
  <div class="suspension">
    <div class="list">
      <div class="list_item">
        <a href="javascript:;">
          <!-- <router-link to="/"> -->
            <div class="list_item_a" @click="$emit('slide', 0)">活动首页</div>
          <!-- </router-link> -->
        </a>
      </div>
      <div class="list_item">
        <a href="javascript:;">
          <div class="list_item_a" @click="$emit('slide', '#card')">
            打卡进行时
          </div>
        </a>
      </div>
      <div class="list_item">
        <a href="javascript:;">
          <router-link to="/index/lookBack">
            <div class="list_item_a" @click="$emit('slide', '.center')">往期回顾</div>
          </router-link>
        </a>
      </div>
      <div class="list_item">
        <a href="javascript:;">
          <router-link to="/index/share">
            <div class="list_item_a" @click="$emit('slide', '.center' )" >学员打卡日记</div>
          </router-link>
        </a>
      </div>
      <div class="list_item">
        <a href="javascript:;">
          <div class="list_item_a" @click="$emit('slide', '#QA')">常见问题</div>
        </a>
      </div>
      <a href="javascript:;" class="backTop" @click="$emit('slide', 0)">
        <div class="backTop"></div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "suspension",
};
</script>

<style lang="less" scoped>
@media (max-width: 1770px) {
  .suspension {
    display: none;
  }
}

.suspension {
  z-index: 99;
  position: fixed;
  left: 3.5625rem;
  top: 8.9375rem;
  box-sizing: border-box;
  padding: 6.375rem 1.6875rem 0 1.5625rem;
  width: 10.5rem;
  height: 26.125rem;
  background: url(https://fview.5kjs.com/activity/21sign/image/pc/indexImage/suspension.png) no-repeat;
  background-size: 100% 100%;
  .list {
    width: 100%;
    height: 100%;
    // background: red;
    .list_item {
      margin-bottom: 0.9375rem;
      width: 7.25rem;
      height: 1.9375rem;
      background: #ffffff;
      box-shadow: 0rem 0.25rem 0.375rem 0rem rgba(255, 54, 0, 0.32),
        0rem 0.1875rem 0.5rem 0rem rgba(244, 107, 25, 0.44);
      border-radius: 0.4375rem;
      line-height: 1.9375rem;
      text-align: center;

      .list_item_a {
        font-size: 1rem;
        font-family: "Microsoft YaHei";
        font-weight: bold;
        color: #f58675;
        div {
          font-size: 1rem;
          font-family: "Microsoft YaHei";
          font-weight: bold;
          color: #f58675;
        }
      }
    }
    .list_item:hover {
      background-color: #ffc672;
      .list_item_a {
        color: #fff;
      }
    }
    .backTop {
      display: block;
      margin: auto;
      width: 3.875rem;
      height: 3.875rem;
      border-radius: 50%;
    }
  }
}
</style>